import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "./Pedidos.css";
import html2pdf from "html2pdf.js";
import logo from "../assets/logoblanco.png";
import Modal from 'react-modal';

Modal.setAppElement('#root');

const Pedidos = () => {
    const [pedidos, setPedidos] = useState([]);
    const [nuevoPedido, setNuevoPedido] = useState({
        cliente: '',
        direccion: '',
        telefono: '',
        productos: [],
        tomadopor: '',
        estado: 'Pendiente',
        descripcion: '',
    });
    const [clientes, setClientes] = useState([]);
    const [productosDisponibles, setProductosDisponibles] = useState([]);
    const [busquedaCliente, setBusquedaCliente] = useState("");
    const [busquedaProducto, setBusquedaProducto] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [descuento, setDescuento] = useState(0);
    const [editandoPedido, setEditandoPedido] = useState(null);
    const [busquedaPedido, setBusquedaPedido] = useState("");
    const [tipoProducto, setTipoProducto] = useState('normal');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [historialModalIsOpen, setHistorialModalIsOpen] = useState(false);
    const [historialProducto, setHistorialProducto] = useState(null);
    const [productosSeleccionadosTemp, setProductosSeleccionadosTemp] = useState([]);
    
    // Estados para paginación mejorada
    const [paginaActual, setPaginaActual] = useState(1);
    const [pedidosPorPagina] = useState(15);
    const [paginacion, setPaginacion] = useState({
        page: 1,
        limit: 15,
        total: 0,
        totalPages: 0,
        search: ''
    });

    const userRole = localStorage.getItem("userRole");
    const userName = localStorage.getItem("username");

    useEffect(() => {
        if (userName) {
            setNuevoPedido((prev) => ({
                ...prev,
                tomadopor: userName,
            }));
        }
    }, [userName]);

    // === FUNCIONES DE CÁLCULO SEGURO - VERSIÓN CORREGIDA ===

    // Función a prueba de errores - VERSIÓN MEJORADA
    const calcularTotalSeguro = (productos) => {
        if (!Array.isArray(productos)) {
            console.error('❌ Productos no es array:', productos);
            return 0;
        }

        let total = 0;
        let errores = [];

        productos.forEach((producto, index) => {
            // Validación EXTREMA de cada campo
            const precio = Number(producto.precio);
            const cantidad = Number(producto.cantidad);
            
            if (isNaN(precio) || precio < 0) {
                errores.push(`Producto ${index}: Precio inválido "${producto.precio}"`);
                return;
            }
            
            if (isNaN(cantidad) || !Number.isInteger(cantidad) || cantidad < 0) {
                errores.push(`Producto ${index}: Cantidad inválida "${producto.cantidad}"`);
                return;
            }

            const subtotalProducto = precio * cantidad;
            
            // Verificar overflow numérico
            if (!isFinite(subtotalProducto)) {
                errores.push(`Producto ${index}: Overflow en cálculo ${precio} * ${cantidad}`);
                return;
            }

            total += subtotalProducto;
            
            console.log(`✅ Producto ${index}: ${producto.nombre} - ${precio} x ${cantidad} = ${subtotalProducto} (tipo: ${producto.tipo})`);
        });

        if (errores.length > 0) {
            console.error('❌ Errores en cálculo:', errores);
            alert('Errores en cálculo: ' + errores.join(', '));
        }

        console.log(`💰 Total calculado: ${total}`);
        return total;
    };

    // Función segura para descuento - VERSIÓN MEJORADA
    const calcularTotalConDescuentoSeguro = (productos, descuentoAplicar = 0) => {
        const subtotal = calcularTotalSeguro(productos);
        const descuento = Number(descuentoAplicar) || 0;
        
        if (descuento < 0 || descuento > 100) {
            console.error('❌ Descuento inválido:', descuento);
            return subtotal;
        }
        
        const totalConDescuento = subtotal * (1 - descuento / 100);
        console.log(`🎯 Subtotal: ${subtotal}, Descuento: ${descuento}%, Total: ${totalConDescuento}`);
        
        return totalConDescuento;
    };

    // FUNCIÓN MODIFICADA: Ahora incluye búsqueda y paginación en el backend
    const fetchPedidos = useCallback(async (page = 1, search = '') => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get("https://backend-vbfh.onrender.com/api/pedidos", {
                params: {
                    page: page,
                    limit: pedidosPorPagina,
                    search: search
                }
            });
            
            if (response.data && Array.isArray(response.data.pedidos)) {
                setPedidos(response.data.pedidos);
                setPaginacion(response.data.pagination);
            } else {
                console.error("La respuesta de la API no tiene el formato esperado:", response.data);
                setPedidos([]);
                setError("Error al cargar los pedidos. Formato de datos incorrecto.");
            }
        } catch (error) {
            console.error("Error al obtener pedidos:", error);
            setPedidos([]);
            setError("Error al cargar los pedidos. Intente nuevamente.");
        } finally {
            setLoading(false);
        }
    }, [pedidosPorPagina]);

    // FUNCIÓN MODIFICADA: Manejar búsqueda con debounce
    const handleBusquedaChange = (valor) => {
        setBusquedaPedido(valor);
        // Resetear a página 1 cuando se busca
        setPaginaActual(1);
        // Hacer la búsqueda después de un pequeño delay
        setTimeout(() => {
            fetchPedidos(1, valor);
        }, 500);
    };

    const fetchClientes = useCallback(async () => {
        try {
            const response = await axios.get("https://backend-vbfh.onrender.com/api/clientes");
            if (Array.isArray(response.data)) {
                setClientes(response.data);
            } else {
                console.error("La respuesta de la API no es un array:", response.data);
                setClientes([]);
            }
        } catch (error) {
            console.error("Error al obtener clientes:", error);
            setClientes([]);
        }
    }, []);

    const fetchProductos = useCallback(async () => {
        try {
            const response = await axios.get("https://backend-vbfh.onrender.com/api/inventario");
            if (Array.isArray(response.data)) {
                setProductosDisponibles(response.data);
            } else {
                console.error("La respuesta de la API no es un array:", response.data);
                setProductosDisponibles([]);
            }
        } catch (error) {
            console.error("Error al obtener productos:", error);
            setProductosDisponibles([]);
        }
    }, []);

    useEffect(() => {
        fetchPedidos(paginaActual, busquedaPedido);
        fetchClientes();
        fetchProductos();
    }, [fetchPedidos, fetchClientes, fetchProductos, paginaActual]);

    const formatPrice = (price) => {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
        }).format(price);
    };

    const formatDate = (dateString) => {
        const fechaObj = new Date(dateString);
        return fechaObj.toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    const limpiarFormulario = () => {
        setNuevoPedido({
            cliente: '',
            direccion: '',
            telefono: '',
            productos: [],
            tomadopor: userName,
            estado: 'Pendiente',
            descripcion: '',
        });
        setDescuento(0);
        setEditandoPedido(null);
        setTipoProducto('normal');
        setProductosSeleccionadosTemp([]);
    };

    const seleccionarCliente = (cliente) => {
        setNuevoPedido((prev) => ({
            ...prev,
            cliente: cliente.nombre,
            direccion: cliente.direccion,
            telefono: cliente.telefono,
        }));
        setBusquedaCliente("");
    };

    // Función para limpiar la búsqueda de productos
    const limpiarBusquedaProducto = () => {
        setBusquedaProducto("");
    };

    // Función para seleccionar/deseleccionar productos temporalmente
    const toggleSeleccionProducto = (producto) => {
        if (producto.cantidad <= 0) {
            alert(`El producto "${producto.nombre}" está agotado.`);
            return;
        }

        setProductosSeleccionadosTemp(prev => {
            const existe = prev.find(p => p.id === producto.id && p.tipo === tipoProducto);
            if (existe) {
                return prev.filter(p => !(p.id === producto.id && p.tipo === tipoProducto));
            } else {
                return [...prev, {
                    ...producto,
                    cantidad: 1,
                    precio: tipoProducto === 'cambio' ? 0 : producto.precio,
                    tipo: tipoProducto,
                }];
            }
        });
    };

    // Función para agregar todos los productos seleccionados
    const agregarProductosSeleccionados = () => {
        if (productosSeleccionadosTemp.length === 0) {
            alert("No hay productos seleccionados para agregar.");
            return;
        }

        // Verificar stock para todos los productos seleccionados
        for (const productoTemp of productosSeleccionadosTemp) {
            const productoInventario = productosDisponibles.find(p => p.id === productoTemp.id);
            
            if (!productoInventario || productoTemp.cantidad > productoInventario.cantidad) {
                alert(`No hay suficiente stock para "${productoTemp.nombre}".\nStock disponible: ${productoInventario?.cantidad || 0}`);
                return;
            }
        }

        // Agregar todos los productos al pedido
        setNuevoPedido(prev => {
            const nuevosProductos = [...prev.productos];
            
            productosSeleccionadosTemp.forEach(productoTemp => {
                const productoExistente = nuevosProductos.find(p => p.id === productoTemp.id && p.tipo === productoTemp.tipo);
                
                if (productoExistente) {
                    const nuevaCantidad = productoExistente.cantidad + productoTemp.cantidad;
                    if (nuevaCantidad > (productosDisponibles.find(p => p.id === productoTemp.id)?.cantidad || 0)) {
                        alert(`No hay suficiente stock para "${productoTemp.nombre}".`);
                        return;
                    }
                    productoExistente.cantidad = nuevaCantidad;
                } else {
                    nuevosProductos.push(productoTemp);
                }
            });

            return {
                ...prev,
                productos: nuevosProductos
            };
        });

        // Limpiar selección temporal
        setProductosSeleccionadosTemp([]);
        setBusquedaProducto("");
    };

    // Función para limpiar selección temporal
    const limpiarSeleccionTemp = () => {
        setProductosSeleccionadosTemp([]);
    };

    const agregarProducto = (producto) => {
        if (producto.cantidad <= 0) {
            alert(`El producto "${producto.nombre}" está agotado.`);
            return;
        }

        const productoExistente = nuevoPedido.productos.find((p) => p.id === producto.id && p.tipo === tipoProducto);
        
        if (productoExistente) {
            const nuevaCantidad = productoExistente.cantidad + 1;
            
            if (nuevaCantidad > producto.cantidad) {
                alert(`No hay suficiente stock para "${producto.nombre}".\nStock disponible: ${producto.cantidad}\nCantidad en pedido: ${productoExistente.cantidad}`);
                return;
            }
            
            actualizarCantidad(producto.id, nuevaCantidad, tipoProducto);
        } else {
            if (producto.cantidad < 1) {
                alert(`No hay suficiente stock para "${producto.nombre}". Stock disponible: ${producto.cantidad}`);
                return;
            }
            
            setNuevoPedido((prev) => ({
                ...prev,
                productos: [
                    ...prev.productos,
                    {
                        ...producto,
                        cantidad: 1,
                        precio: tipoProducto === 'cambio' ? 0 : producto.precio,
                        tipo: tipoProducto,
                    },
                ],
            }));
        }
        setBusquedaProducto("");
    };

    const actualizarCantidad = (id, cantidad, tipo) => {
        // Obtener el producto del inventario para verificar stock
        const productoInventario = productosDisponibles.find(p => p.id === id);
        
        if (!productoInventario) {
            alert("Producto no encontrado en el inventario");
            return;
        }
        
        // Verificar stock para todos los tipos de productos
        if (cantidad > productoInventario.cantidad) {
            alert(`No hay suficiente stock para este producto.\nStock disponible: ${productoInventario.cantidad}`);
            return;
        }
        
        setNuevoPedido((prev) => ({
            ...prev,
            productos: prev.productos.map((producto) =>
                producto.id === id && producto.tipo === tipo ? { ...producto, cantidad } : producto
            ),
        }));
    };

    const actualizarPrecio = (id, precio) => {
        setNuevoPedido((prev) => ({
            ...prev,
            productos: prev.productos.map((producto) =>
                producto.id === id ? { ...producto, precio } : producto
            ),
        }));
    };

    const eliminarProducto = (id) => {
        setNuevoPedido((prev) => ({
            ...prev,
            productos: prev.productos.filter((producto) => producto.id !== id),
        }));
    };

    const crearPedido = async () => {
        setLoading(true);
        setError(null);
        try {
            if (nuevoPedido.productos.length === 0) {
                throw new Error("Debes agregar al menos un producto al pedido.");
            }

            if (!nuevoPedido.cliente || !nuevoPedido.direccion || !nuevoPedido.telefono) {
                throw new Error("Debes seleccionar un cliente válido.");
            }

            // Verificación adicional de stock antes de enviar
            for (const producto of nuevoPedido.productos) {
                const productoInventario = productosDisponibles.find(p => p.id === producto.id);
                if (!productoInventario || producto.cantidad > productoInventario.cantidad) {
                    throw new Error(`No hay suficiente stock para "${producto.nombre}".\nStock disponible: ${productoInventario?.cantidad || 0}\nCantidad solicitada: ${producto.cantidad}`);
                }
            }

            // Verificar precios para trabajadores
            if (userRole === "trabajador") {
                for (const producto of nuevoPedido.productos) {
                    const productoOriginal = productosDisponibles.find(p => p.id === producto.id);
                    if (producto.precio < productoOriginal.precio) {
                        throw new Error(`No puedes establecer un precio menor al precio original (${productoOriginal.precio}) para el producto ${producto.nombre}.`);
                    }
                }
            }

            const fecha = new Date().toISOString();
            const datosPedido = {
                ...nuevoPedido,
                fecha,
                descuento,
                tomadopor: userName,
            };

            const response = await axios.post("https://backend-vbfh.onrender.com/api/pedidos", datosPedido);

            if (response.data && response.data.pedidoId) {
                alert(`Pedido creado con ID: ${response.data.pedidoId}`);
            } else {
                throw new Error("No se recibió un ID de pedido válido.");
            }

            limpiarFormulario();
            setShowForm(false);
            fetchPedidos(paginaActual, busquedaPedido);
            fetchProductos();
        } catch (error) {
            console.error("Error al crear pedido:", error);
            setError(error.response?.data?.details || error.message);
        } finally {
            setLoading(false);
        }
    };

    const editarPedido = (pedido) => {
        setEditandoPedido(pedido);
        setNuevoPedido({
            cliente: pedido.cliente,
            direccion: pedido.direccion,
            telefono: pedido.telefono,
            productos: pedido.productos.map(producto => ({
                id: producto.idProducto || producto.id,
                nombre: producto.nombreProducto || producto.nombre || 'Nombre no disponible',
                cantidad: producto.cantidad,
                precio: producto.precio,
                tipo: producto.tipo || 'normal',
            })),
            tomadopor: pedido.tomadopor,
            estado: pedido.estado,
            descripcion: pedido.descripcion,
        });
        setDescuento(pedido.descuento || 0);
        setShowForm(true);
    };
    
    const actualizarPedido = async () => {
        setLoading(true);
        setError(null);
        try {
            if (nuevoPedido.productos.length === 0) {
                throw new Error("Debes agregar al menos un producto al pedido.");
            }
    
            if (!nuevoPedido.cliente || !nuevoPedido.direccion || !nuevoPedido.telefono) {
                throw new Error("Debes seleccionar un cliente válido.");
            }
    
            // Verificación adicional de stock antes de enviar
            for (const producto of nuevoPedido.productos) {
                const productoInventario = productosDisponibles.find(p => p.id === producto.id);
                if (!productoInventario || producto.cantidad > productoInventario.cantidad) {
                    throw new Error(`No hay suficiente stock para "${producto.nombre}".\nStock disponible: ${productoInventario?.cantidad || 0}\nCantidad solicitada: ${producto.cantidad}`);
                }
            }
    
            // Verificar precios para trabajadores
            if (userRole === "trabajador") {
                for (const producto of nuevoPedido.productos) {
                    const productoOriginal = productosDisponibles.find(p => p.id === producto.id);
                    if (producto.precio < productoOriginal.precio) {
                        throw new Error(`No puedes establecer un precio menor al precio original (${productoOriginal.precio}) para el producto ${producto.nombre}.`);
                    }
                }
            }
    
            const datosPedido = {
                ...nuevoPedido,
                descuento,
            };
    
            await axios.put(`https://backend-vbfh.onrender.com/api/pedidos/${editandoPedido.id}`, datosPedido);
    
            alert("Pedido actualizado correctamente.");
    
            limpiarFormulario();
            setShowForm(false);
            fetchPedidos(paginaActual, busquedaPedido);
            fetchProductos();
        } catch (error) {
            console.error("Error al actualizar pedido:", error);
            setError(error.response?.data?.details || error.message);
        } finally {
            setLoading(false);
        }
    };

    const eliminarPedido = async (id) => {
        if (!window.confirm("¿Estás seguro de que deseas eliminar este pedido? Esta acción no se puede deshacer.")) {
            return;
        }

        setLoading(true);
        setError(null);
        try {
            await axios.delete(`https://backend-vbfh.onrender.com/api/pedidos/${id}`);
            fetchPedidos(paginaActual, busquedaPedido);
            fetchProductos();
            alert("Pedido eliminado correctamente.");
        } catch (error) {
            console.error("Error al eliminar pedido:", error);
            setError("Hubo un error al eliminar el pedido.");
        } finally {
            setLoading(false);
        }
    };

    const imprimirPedido = (pedido) => {
        const contenido = document.getElementById(`pedido-to-print-${pedido.id}`);

        contenido.style.display = 'block';

        const opciones = {
            margin: 10,
            filename: `remision_${pedido.numeroremision}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        html2pdf()
            .from(contenido)
            .set(opciones)
            .toPdf()
            .get('pdf')
            .then((pdf) => {
                const blob = pdf.output('blob');
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                contenido.style.display = 'none';
            });
    };

    const clientesFiltrados = clientes.filter((cliente) =>
        cliente.nombre.toLowerCase().includes(busquedaCliente.toLowerCase())
    );

    // MODIFICACIÓN: Filtrar productos para mostrar solo los que tienen stock o marcarlos como agotados
    const productosFiltrados = productosDisponibles.filter((producto) =>
        (producto.nombre.toLowerCase().includes(busquedaProducto.toLowerCase()) ||
        producto.id.toString().includes(busquedaProducto))
    );

    // FUNCIONES MODIFICADAS: Ahora la paginación se maneja desde el backend
    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
        fetchPedidos(numeroPagina, busquedaPedido);
        // Scroll hacia arriba cuando cambia de página
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const paginaSiguiente = () => {
        if (paginaActual < paginacion.totalPages) {
            const nuevaPagina = paginaActual + 1;
            setPaginaActual(nuevaPagina);
            fetchPedidos(nuevaPagina, busquedaPedido);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const paginaAnterior = () => {
        if (paginaActual > 1) {
            const nuevaPagina = paginaActual - 1;
            setPaginaActual(nuevaPagina);
            fetchPedidos(nuevaPagina, busquedaPedido);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Generar números de página para mostrar
    const numerosPagina = [];
    const paginasAMostrar = 5; // Número máximo de páginas a mostrar en la paginación
    
    let inicioPaginas = Math.max(1, paginacion.page - Math.floor(paginasAMostrar / 2));
    let finPaginas = Math.min(paginacion.totalPages, inicioPaginas + paginasAMostrar - 1);
    
    // Ajustar si estamos cerca del final
    if (finPaginas - inicioPaginas + 1 < paginasAMostrar) {
        inicioPaginas = Math.max(1, finPaginas - paginasAMostrar + 1);
    }
    
    for (let i = inicioPaginas; i <= finPaginas; i++) {
        numerosPagina.push(i);
    }

    return (
        <div className="pedido-container">
            <h2>Gestión de Pedidos</h2>

            {error && <div className="error-message">{error}</div>}
            {loading && <div className="loading-indicator">Cargando...</div>}

            {/* Lista de pedidos */}
            <div className="lista-pedidos">
                <h3>Pedidos Realizados</h3>
                <div className="barra-busqueda">
                    <input
                        type="text"
                        placeholder="Buscar por número de remisión o cliente..."
                        value={busquedaPedido}
                        onChange={(e) => handleBusquedaChange(e.target.value)}
                    />
                </div>

                {/* Información de paginación */}
                <div className="info-paginacion">
                    <p>
                        Mostrando {pedidos.length} de {paginacion.total} pedidos 
                        (Página {paginacion.page} de {paginacion.totalPages})
                        {busquedaPedido && <span> - Búsqueda: "{busquedaPedido}"</span>}
                    </p>
                </div>

                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Cliente</th>
                                <th>N° Remisión</th>
                                <th>Tomado Por</th>
                                <th>Estado</th>
                                <th>Total</th>
                                <th>Fecha y Hora</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(pedidos) && pedidos.map((pedido) => {
                                const productos = Array.isArray(pedido.productos) ? pedido.productos : [];
                                
                                // ✅ CORRECCIÓN CRÍTICA: Usar la función de cálculo seguro
                                const totalConDescuento = calcularTotalConDescuentoSeguro(productos, pedido.descuento);
                                
                                return (
                                    <tr key={pedido.id}>
                                        <td>{pedido.id}</td>
                                        <td>{pedido.cliente}</td>
                                        <td>{pedido.numeroremision}</td>
                                        <td>{pedido.tomadopor}</td>
                                        <td>
                                            <span className={`estado-${pedido.estado.toLowerCase().replace(' ', '-')}`}>
                                                {pedido.estado}
                                            </span>
                                        </td>
                                        <td>{formatPrice(totalConDescuento)}</td>
                                        <td>{formatDate(pedido.fecha)}</td>
                                        <td>
                                            <div className="action-buttons">
                                                <button 
                                                    onClick={() => imprimirPedido(pedido)} 
                                                    className="print-button"
                                                >
                                                    Imprimir
                                                </button>
                                                {userRole === "admin" && (
                                                    <>
                                                        <button 
                                                            onClick={() => editarPedido(pedido)} 
                                                            className="edit-button"
                                                        >
                                                            Editar
                                                        </button>
                                                        <button 
                                                            onClick={() => eliminarPedido(pedido.id)} 
                                                            className="delete-button"
                                                        >
                                                            Eliminar
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                {/* Paginación */}
                {paginacion.totalPages > 1 && (
                    <div className="paginacion-container">
                        <button 
                            className={`boton-paginacion ${paginaActual === 1 ? 'boton-deshabilitado' : ''}`}
                            onClick={paginaAnterior}
                            disabled={paginaActual === 1}
                        >
                            ‹ Anterior
                        </button>
                        
                        {/* Mostrar primera página si no está en el rango */}
                        {inicioPaginas > 1 && (
                            <>
                                <button 
                                    className={`numero-pagina ${1 === paginaActual ? 'pagina-actual' : ''}`}
                                    onClick={() => cambiarPagina(1)}
                                >
                                    1
                                </button>
                                {inicioPaginas > 2 && <span className="puntos-suspensivos">...</span>}
                            </>
                        )}

                        {/* Números de página */}
                        {numerosPagina.map(numero => (
                            <button
                                key={numero}
                                className={`numero-pagina ${numero === paginaActual ? 'pagina-actual' : ''}`}
                                onClick={() => cambiarPagina(numero)}
                            >
                                {numero}
                            </button>
                        ))}

                        {/* Mostrar última página si no está en el rango */}
                        {finPaginas < paginacion.totalPages && (
                            <>
                                {finPaginas < paginacion.totalPages - 1 && <span className="puntos-suspensivos">...</span>}
                                <button 
                                    className={`numero-pagina ${paginacion.totalPages === paginaActual ? 'pagina-actual' : ''}`}
                                    onClick={() => cambiarPagina(paginacion.totalPages)}
                                >
                                    {paginacion.totalPages}
                                </button>
                            </>
                        )}

                        <button 
                            className={`boton-paginacion ${paginaActual === paginacion.totalPages ? 'boton-deshabilitado' : ''}`}
                            onClick={paginaSiguiente}
                            disabled={paginaActual === paginacion.totalPages}
                        >
                            Siguiente ›
                        </button>
                    </div>
                )}
            </div>

            {/* Botón para mostrar el formulario de creación de pedidos */}
            {(userRole === "admin" || userRole === "trabajador") && (
                <button 
                    onClick={() => { setShowForm(!showForm); limpiarFormulario(); }} 
                    className="crear-pedido-button"
                >
                    {showForm ? "Cancelar" : "Crear Pedido"}
                </button>
            )}

            {/* Formulario para crear o editar pedido */}
            {showForm && (
                <div className="nuevo-pedido">
                    <h3>{editandoPedido ? "Editar Pedido" : "Crear Nuevo Pedido"}</h3>
                    <div className="formulario">
                        <label>
                            Cliente:
                            <input
                                type="text"
                                placeholder="Buscar cliente..."
                                value={busquedaCliente}
                                onChange={(e) => setBusquedaCliente(e.target.value)}
                            />
                            {busquedaCliente && (
                                <ul className="clientes-list">
                                    {Array.isArray(clientesFiltrados) && clientesFiltrados.map((cliente) => (
                                        <li 
                                            key={cliente.id} 
                                            onClick={() => seleccionarCliente(cliente)}
                                            className="cliente-item"
                                        >
                                            {cliente.nombre} - {cliente.direccion} - {cliente.telefono}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </label>
                        {nuevoPedido.cliente && (
                            <div className="info-cliente-seleccionado">
                                <p><strong>Cliente:</strong> {nuevoPedido.cliente}</p>
                                <p><strong>Dirección:</strong> {nuevoPedido.direccion}</p>
                                <p><strong>Teléfono:</strong> {nuevoPedido.telefono}</p>
                            </div>
                        )}
                        <label>
                            Descuento (%):
                            <input
                                type="number"
                                value={descuento}
                                min="0"
                                max="100"
                                onChange={(e) => setDescuento(parseFloat(e.target.value))}
                            />
                        </label>
                        <label>
                            Descripción:
                            <textarea
                                value={nuevoPedido.descripcion}
                                onChange={(e) => setNuevoPedido((prev) => ({ ...prev, descripcion: e.target.value }))}
                                placeholder="Notas adicionales sobre el pedido..."
                            />
                        </label>
                    </div>

                    {/* Barra de búsqueda para productos */}
                    <div className="busqueda-productos">
                        <h4>Agregar Productos</h4>
                        <div className="producto-options">
                            <select
                                value={tipoProducto}
                                onChange={(e) => setTipoProducto(e.target.value)}
                                className="tipo-producto-select"
                            >
                                <option value="normal">Normal</option>
                                <option value="cambio">Cambio</option>
                            </select>
                            <div className="search-container">
                                <input
                                    type="text"
                                    placeholder="Buscar producto por nombre o ID..."
                                    value={busquedaProducto}
                                    onChange={(e) => setBusquedaProducto(e.target.value)}
                                    className="product-search-input"
                                />
                                {busquedaProducto && (
                                    <button 
                                        onClick={limpiarBusquedaProducto}
                                        className="clear-search-button"
                                        title="Limpiar búsqueda"
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Contador de productos seleccionados y botones de acción */}
                        {productosSeleccionadosTemp.length > 0 && (
                            <div className="seleccion-temporal">
                                <div className="seleccion-info">
                                    <span>{productosSeleccionadosTemp.length} producto(s) seleccionado(s)</span>
                                    <div className="seleccion-buttons">
                                        <button 
                                            onClick={agregarProductosSeleccionados}
                                            className="add-selected-button"
                                        >
                                            Agregar Seleccionados
                                        </button>
                                        <button 
                                            onClick={limpiarSeleccionTemp}
                                            className="clear-selection-button"
                                        >
                                            Limpiar Selección
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {busquedaProducto && (
                            <ul className="productos-list">
                                {Array.isArray(productosFiltrados) && productosFiltrados.map((producto) => {
                                    const estaSeleccionado = productosSeleccionadosTemp.some(
                                        p => p.id === producto.id && p.tipo === tipoProducto
                                    );
                                    const estaAgotado = producto.cantidad <= 0;
                                    
                                    return (
                                        <li 
                                            key={producto.id} 
                                            className={`producto-item ${estaSeleccionado ? 'seleccionado' : ''} ${estaAgotado ? 'agotado' : ''}`}
                                            onClick={() => !estaAgotado && toggleSeleccionProducto(producto)}
                                        >
                                            <div className="producto-info">
                                                <span className="producto-nombre">{producto.nombre}</span>
                                                <span className="producto-precio">{formatPrice(producto.precio)}</span>
                                                <span className={`producto-stock ${estaAgotado ? "sin-stock" : "con-stock"}`}>
                                                    {estaAgotado ? "(AGOTADO)" : `(Stock: ${producto.cantidad})`}
                                                </span>
                                            </div>
                                            <div className="producto-actions">
                                                {estaAgotado ? (
                                                    <span className="agotado-indicator">AGOTADO</span>
                                                ) : (
                                                    <span className="seleccion-indicator">
                                                        {estaSeleccionado ? '✓' : '+'}
                                                    </span>
                                                )}
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>

                    {/* Productos seleccionados */}
                    <div className="productos-seleccionados">
                        <h4>Productos en el Pedido</h4>
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Producto</th>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Disponible</th>
                                        <th>Precio Unitario</th>
                                        <th>Total</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(nuevoPedido.productos) && nuevoPedido.productos.map((producto) => {
                                        const productoInventario = productosDisponibles.find(p => p.id === producto.id) || { cantidad: 0 };
                                        return (
                                            <tr key={`${producto.id}-${producto.tipo}`}>
                                                <td>{producto.id}</td>
                                                <td>{producto.nombre}</td>
                                                <td>
                                                    <span className={`tipo-${producto.tipo}`}>
                                                        {producto.tipo}
                                                    </span>
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={producto.cantidad}
                                                        min="1"
                                                        max={producto.tipo === 'cambio' ? '' : productoInventario.cantidad + producto.cantidad}
                                                        onChange={(e) =>
                                                            actualizarCantidad(producto.id, parseInt(e.target.value), producto.tipo)
                                                        }
                                                        className="cantidad-input"
                                                    />
                                                </td>
                                                <td className={productoInventario.cantidad <= 0 ? "sin-stock" : "con-stock"}>
                                                    {producto.tipo === 'cambio' ? 'N/A' : productoInventario.cantidad}
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={producto.precio}
                                                        onChange={(e) =>
                                                            actualizarPrecio(producto.id, parseFloat(e.target.value))
                                                        }
                                                        disabled={producto.tipo === 'cambio'}
                                                        className="precio-input"
                                                    />
                                                </td>
                                                <td>{formatPrice(producto.precio * producto.cantidad)}</td>
                                                <td>
                                                    <button 
                                                        onClick={() => eliminarProducto(producto.id)} 
                                                        className="remove-product-button"
                                                    >
                                                        Eliminar
                                                    </button>
                            
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="resumen-total">
                        <p><strong>Subtotal:</strong> {formatPrice(calcularTotalSeguro(nuevoPedido.productos))}</p>
                        {descuento > 0 && <p><strong>Descuento ({descuento}%):</strong> -{formatPrice(calcularTotalSeguro(nuevoPedido.productos) * (descuento / 100))}</p>}
                        <p className="total-final"><strong>Total con Descuento:</strong> {formatPrice(calcularTotalConDescuentoSeguro(nuevoPedido.productos, descuento))}</p>
                    </div>

                    <button 
                        onClick={editandoPedido ? actualizarPedido : crearPedido} 
                        className="boton-crear"
                        disabled={loading}
                    >
                        {editandoPedido ? "Actualizar Pedido" : "Crear Pedido"}
                    </button>
                </div>
            )}

            {/* Plantilla para imprimir */}
            {Array.isArray(pedidos) && pedidos.map((pedido) => (
                <div key={pedido.id} id={`pedido-to-print-${pedido.id}`} className="pedido-imprimir" style={{ display: 'none' }}>
                    <div className="encabezado">
                        <img src={logo} alt="Logo Ferretería" className="logo" />
                        <div className="info-empresa">
                            <h2>Distribuciones Aristizabal</h2>
                            <p>David Aristizábal Agudelo</p>
                            <p>Ahorros Bancolombia 912-040543-69</p>
                            <p>NIT: 1039458305-0</p>
                            <p>Dirección: Carrera 36a #66g 64, Manrique Oriental</p>
                            <p>Celular: +57 310 6031424</p>
                        </div>
                    </div>
                    <div className="info-pedido">
                        <h3>Remisión de Pedido #{pedido.numeroremision}</h3>
                        <table className="info-cliente">
                            <tbody>
                                <tr>
                                    <td><strong>Fecha:</strong></td>
                                    <td>{new Date(pedido.fecha).toLocaleDateString()}</td>
                                </tr>
                                <tr>
                                    <td><strong>Cliente:</strong></td>
                                    <td>{pedido.cliente}</td>
                                </tr>
                                <tr>
                                    <td><strong>Dirección:</strong></td>
                                    <td>{pedido.direccion}</td>
                                </tr>
                                <tr>
                                    <td><strong>Teléfono:</strong></td>
                                    <td>{pedido.telefono}</td>
                                </tr>
                                <tr>
                                    <td><strong>Tomado Por:</strong></td>
                                    <td>{pedido.tomadopor}</td>
                                </tr>
                                <tr>
                                    <td><strong>Descripción:</strong></td>
                                    <td>{pedido.descripcion}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <table className="tabla-productos">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Producto</th>
                                <th>Tipo</th>
                                <th>Cantidad</th>
                                <th>Precio Unitario</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(pedido.productos) && pedido.productos.map((producto) => (
                                <tr key={producto.id}>
                                    <td>{producto.idProducto || producto.id}</td>
                                    <td>{producto.nombreProducto || producto.nombre || 'Nombre no disponible'}</td>
                                    <td>{producto.tipo}</td>
                                    <td>{producto.cantidad}</td>
                                    <td>{formatPrice(producto.precio)}</td>
                                    <td>{formatPrice(producto.precio * producto.cantidad)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="total">
                        <p><strong>Subtotal:</strong> {formatPrice(calcularTotalSeguro(pedido.productos))}</p>
                        {pedido.descuento > 0 && <p><strong>Descuento:</strong> {pedido.descuento}%</p>}
                        <p className="total-final"><strong>Total con Descuento:</strong> {formatPrice(calcularTotalConDescuentoSeguro(pedido.productos, pedido.descuento))}</p>
                    </div>
                </div>
            ))}

            {/* Modal de Historial de Producto */}
            <Modal
                isOpen={historialModalIsOpen}
                onRequestClose={() => setHistorialModalIsOpen(false)}
                contentLabel="Historial de Producto"
                className="modal"
                overlayClassName="overlay"
            >
                {historialProducto && (
                    <>
                        <div className="modal-header">
                            <h2>Historial de Inventario: {historialProducto.producto?.nombre}</h2>
                            <button 
                                onClick={() => setHistorialModalIsOpen(false)} 
                                className="close-modal-button"
                            >
                                &times;
                            </button>
                        </div>
                        <div className="modal-body">
                            {loading ? (
                                <div className="loading-indicator">Cargando historial...</div>
                            ) : historialProducto.historial.length > 0 ? (
                                <table className="historial-table">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Cant. Anterior</th>
                                            <th>Cant. Nueva</th>
                                            <th>Diferencia</th>
                                            <th>Motivo</th>
                                            <th>Usuario</th>
                                            <th>Pedido</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historialProducto.historial.map((item) => (
                                            <tr key={item.id}>
                                                <td>{formatDate(item.fecha)}</td>
                                                <td>{item.cantidad_anterior}</td>
                                                <td>{item.cantidad_nueva}</td>
                                                <td className={item.diferencia > 0 ? "positivo" : "negativo"}>
                                                    {item.diferencia > 0 ? `+${item.diferencia}` : item.diferencia}
                                                </td>
                                                <td>{item.motivo}</td>
                                                <td>{item.usuario_nombre || item.usuario || 'Sistema'}</td>
                                                <td>
                                                    {item.numeroremision ? (
                                                        <a 
                                                            href={`/pedidos?search=${item.numeroremision}`} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                        >
                                                            {item.numeroremision}
                                                        </a>
                                                    ) : 'N/A'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="no-history">No hay registros de historial para este producto.</div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button 
                                onClick={() => setHistorialModalIsOpen(false)} 
                                className="close-button"
                            >
                                Cerrar
                            </button>
                        </div>
                    </>
                )}
            </Modal>
        </div>
    );
};

export default Pedidos;